
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { DollarSign } from "lucide-react";
import QuoteForm from "./QuoteForm";
import { useQuotes } from "@/hooks/useQuotes";
import { useUserRoles } from "@/hooks/useUserRoles";

interface NewQuoteFormProps {
  bookingId: string;
  onQuoteCreated: () => void;
}

const NewQuoteForm = ({
  bookingId,
  onQuoteCreated
}: NewQuoteFormProps) => {
  const { data: quotes = [] } = useQuotes(bookingId);
  const { roles } = useUserRoles();
  const isFirstQuote = quotes.length === 0;

  const handleQuoteCreated = async () => {
    onQuoteCreated();
  };

  return (
    <Card>
      <CardContent className="py-4">
        <QuoteForm 
          bookingId={bookingId} 
          onQuoteAdded={handleQuoteCreated} 
          isAdmin={roles.isAdmin}
          isFirstQuote={isFirstQuote}
        />
      </CardContent>
    </Card>
  );
};

export default NewQuoteForm;
